import { Node } from 'slate';
import {
  DEFINITIONS as PLUGIN_DEFINITIONS,
  TEXT_DEFINITIONS as QUOTE_TEXT_DEFINITIONS,
  SOURCE_DEFINITIONS as QUOTE_SOURCE_DEFINITIONS,
} from '@xingternal/content-editor-plugin-quote';

import {
  DESERIALIZATION,
  SERIALIZATION,
  QUOTE_FIELDNAME,
  QUOTE_TYPENAME,
} from '../constants';

const DEFINITIONS = {
  ...PLUGIN_DEFINITIONS,
  __typename: QUOTE_TYPENAME,
};

const quoteSerializer = ({ createBlock, matchBlock, node, direction }) => {
  if (matchBlock({ node, match: DEFINITIONS })) {
    if (direction === SERIALIZATION) {
      const quoteText = Node.child(node, 0);
      const quoteSource = Node.child(node, 1);

      return {
        [QUOTE_FIELDNAME]: {
          text: Node.string(quoteText),
          source: Node.string(quoteSource),
        },
      };
    }
    if (direction === DESERIALIZATION) {
      return createBlock({
        node,
        definitions: DEFINITIONS,
        children: [
          {
            type: QUOTE_TEXT_DEFINITIONS.type,
            children: [{ text: node.text }],
          },
          {
            type: QUOTE_SOURCE_DEFINITIONS.type,
            children: [{ text: node.source }],
          },
        ],
      });
    }
  }
};

export { quoteSerializer };
